// App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import React, { useEffect } from "react";
import { useMediaQuery } from "@mui/material";

// Sayfalar
import Login from "./page/Login";
import ForgetPassword from "./page/ForgetPassword";
import Dashboard from "./page/Dashboard";

// Layout
import Layout from "./Layout";

// CSS
import "./css/style.css";
import './index.css';

// DataContext
import { useData } from "./data/general/DataContext";
import ServicePage from "./page/ServisPage";
import PersonelPage from "./page/PersonelPage";
import CustomerPage from "./page/CustomerPage";
import CashPage from "./page/CashPage";
import WarehousePage from "./page/WarehousePage";
import OfferPage from "./page/OfferPage";
import ActionPage from "./page/ActionPage";
import BrandsPage from "./page/BrandsPage";
import DevicesPage from "./page/DevicesPage";
import VehiclesPage from "./page/VehiclesPage";
import SuppliersPage from "./page/SuppliersPage";
import DealersPage from "./page/DealersPage";

function App() {
  const isLoggedIn = false; // Örnek: kullanıcı giriş durumunu buradan kontrol et
  const { setWindowMode } = useData();

  // ✅ Material-UI'de useMediaQuery doğru kullanım bu
  const isMobile = useMediaQuery("(max-width:767px)");

  // Ekran boyutuna göre windowMode belirle
  useEffect(() => {
    setWindowMode(isMobile ? "mobile" : "web");
  }, [isMobile, setWindowMode]);

  return (
    <Router>
      <Routes>
        {/* "/" açılırsa login sayfasına yönlendir */}
        <Route path="/" element={<Navigate to="/girisyap" replace />} />

        {/* Giriş ve şifre unutma sayfaları */}
        <Route path="/girisyap" element={<Login />} />
        <Route path="/sifremi-unuttum" element={<ForgetPassword />} />

        {/* Dashboard, Layout ile sarmalanmış */}
        <Route path="/admin" element={<Layout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="servisler" element={<ServicePage />} />
          <Route path="personel" element={<PersonelPage />} />
          <Route path="müşteriler" element={<CustomerPage/>} />
          <Route path="kasa" element={<CashPage/>} />
          <Route path="depo" element={<WarehousePage/>} />
          <Route path="teklif" element={<OfferPage/>} />
          <Route path="aksiyon-turleri" element={<ActionPage/>} />
          <Route path="markalar" element={<BrandsPage/>} />
          <Route path="cihazlar" element={<DevicesPage/>} />
          <Route path="araçlar" element={<VehiclesPage/>} />
          <Route path="tedarikçiler" element={<SuppliersPage/>} />
          <Route path="bayiler" element={<DealersPage/>} />

        </Route>
      </Routes>
    </Router>
  );
}

export default App;
